"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _ConfirmationModal = _interopRequireDefault(require("./ConfirmationModal.jss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ConfirmationModal = ({
  open,
  onClose,
  message
}) => {
  const classes = (0, _ConfirmationModal.default)();
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    className: classes.modal,
    "aria-labelledby": "simple-modal-title",
    "aria-describedby": "simple-modal-description",
    open: open,
    onClose: () => onClose(false)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.paper
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h5",
    gutterBottom: true
  }, "Confirm"), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.topMargin
  }, message), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.topMargin
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "primary",
    type: "submit",
    id: "confirm-modal-yes-btn",
    className: classes.button,
    onClick: () => onClose(true)
  }, "Yes"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "default",
    type: "submit",
    id: "confirm-modal-no-btn",
    className: classes.button,
    onClick: () => onClose(false)
  }, "No"))));
};
ConfirmationModal.propTypes = {
  open: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  message: _propTypes.default.string
};
ConfirmationModal.defaultProps = {
  open: false,
  onClose: () => {},
  message: ''
};
var _default = ConfirmationModal;
exports.default = _default;